import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { studentCreationApi } from "../server/institutionAllApi";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const AddStudent = () => {
  const [formState, setFormState] = useState({
    name: "",
    email: "",
    mobile: "",
    country_code: "",
    address: "",
    user_name: "",
    // education: "",
    gender: "",
    visa_status: "",
    sourse: "",
    guest_id: "",
    login_id: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedCourseCategory, setSelectedCourseCategory] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedBatch, setSelectedBatch] = useState("");
  const [token, setToken] = useState("");
  const [courseCategories, setCourseCategories] = useState("");
  const [courses, setCourses] = useState([]);
  const [batches, setBatches] = useState([]);
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState([]);
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState([]);
  const [cities, setCities] = useState([]);
  const [isNameTouched, setIsNameTouched] = useState(false);
  const [isMobileTouched, setIsMobileTouched] = useState(false);
  const [selectedCity, setSelectedCity] = useState([]);
  const [selectedEducation, setSelectedEducation] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const navigate = useNavigate();
  const [imagePreview, setImagePreview] = useState(
    "assets/images/user-grid/user-grid-img13.png"
  );

  const location = useLocation();
  const guestToStudent = location.state?.user;

  const readURL = (input) => {
    if (input.target.files && input.target.files[0]) {
      const file = input.target.files[0];

      // Allowed image types
      const allowedTypes = [
        "image/png",
        "image/jpeg",
        "image/jpg",
        "image/gif",
      ];

      if (!allowedTypes.includes(file.type)) {
        setSnackbarMessage(
          "Invalid file format! Please upload an image (PNG, JPG, JPEG, GIF)."
        );
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
        return; // Stop further execution
      }

      // If valid image, read and preview it
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (guestToStudent) {
      fetchGuestToStudentData();
    }
    // const token1 = localStorage.getItem("token");
    const token1 = localStorage.getItem("token");
    setToken(token1);
    if (!token1) {
      // console.log("Access required");
      return;
    }
    fetchBatches();
    fetchdCountry();
  }, []);

  useEffect(() => {
    fetchStatesByCountry();
  }, [selectedCountry]);

  useEffect(() => {
    fetchCityByState();
  }, [selectedState]);

  const fetchGuestToStudentData = async () => {
    setFormState({
      name: guestToStudent?.name,
      email: guestToStudent?.email,
      mobile: guestToStudent?.mobile,
      address: guestToStudent?.address,
      user_name: guestToStudent?.username,
      country_code: guestToStudent?.country_code || "", // Ensure country_code is set
      // education: "",
      gender: "",
      visa_status: "",
      sourse: guestToStudent?.guestData?.sourse,
      guest_id: guestToStudent?.guestData?.guest_id,
      login_id: guestToStudent?._id,
    });
  };

  const fetchBatches = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-batches`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setBatches(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchdCountry = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-countries`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setCountries(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchStatesByCountry = async () => {
    // console.log("selecetd countryyy: ", selectedCountry);
    if (!selectedCountry) {
      // console.log("selecetd countryyy: ", selectedCountry);

      return;
    }
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-states/${selectedCountry}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setStates(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchCityByState = async () => {
    if (!selectedState) {
      return;
    }
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-cities/${selectedState}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setCities(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const [qualifications] = useState([
    "GCSEs (General Certificate of Secondary Education)",
    "IGCSEs (International General Certificate of Secondary Education)",
    "A-Levels (Advanced Level)",
    "AS Levels (Advanced Subsidiary Level)",
    "BTEC (Business and Technology Education Council) Level 2/3",
    "NVQs (National Vocational Qualifications)",
    "T Levels",
    "BTECs (Level 3 and higher)",
    "Foundation Degrees",
    "Bachelor’s Degrees",
    "Integrated Master’s Degrees",
    "Higher National Certificates (HNCs) and Diplomas (HNDs)",
    "PGCE (Postgraduate Certificate in Education)",
    "Master’s Degrees",
    "Doctorates",
    "Postgraduate Diplomas and Certificates",
    "IELTS (International English Language Testing System)",
    "Cambridge English Qualifications",
    "Scottish Qualifications",
    "Welsh Baccalaureate",
    "International Baccalaureate (IB)",
  ]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "name") {
      const regex = /^[A-Za-z\s]*$/; // Allow only alphabets and spaces
      if (!regex.test(value)) return; // Prevent updating state if invalid input
    }

    setFormState({
      ...formState,
      [name]: value,
    });
  };

  // snackbar
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return; // Prevent multiple submissions

    if (formState.name && formState.name.length < 2) {
      setError(true);
      return;
    }

    if (formState.mobile.length < 8 || formState.mobile.length > 15) {
      setError(true);
      return;
    }

    setLoading(true); // Start loading state

    try {
      if (!token) {
        // console.log("Access required");
        return;
      }

      // Create FormData object
      const formData = new FormData();
      formData.append("name", formState.name);
      formData.append("email", formState.email);
      formData.append("mobile", formState.mobile);
      formData.append("address", formState.address);
      formData.append("user_name", formState.user_name);
      formData.append("education", selectedEducation);
      formData.append("country", formState.country);
      formData.append("state", formState.state);
      formData.append("gender", formState.gender);
      formData.append("visa_status", formState.visa_status);
      formData.append("sourse", formState.sourse);
      formData.append("guest_id", formState.guest_id);
      formData.append("login_id", formState.login_id);

      // Add the selected department, course category, course, and batch
      formData.append("selectedBatch", selectedBatch);
      formData.append("selectedCountry", selectedCountry);
      formData.append("selectedState", selectedState);
      formData.append("selectedCity", selectedCity);
      // Append the selected image file (if any)
      const imageInput = document.querySelector("#student-image");
      if (imageInput && imageInput.files[0]) {
        formData.append("image", imageInput.files[0]);
      }

      // Make the POST request with FormData
      const response = await axios.post(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/add-student`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // console.log("Response:", response.data);
      // Navigate to student list after successful creation
      if (response.status === 201) {
        setSnackbarMessage("Created successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/student-list");
        }, 2000);
      }
    } catch (err) {
      setLoading(false); // End loading state
      if (err.response && err.response.status === 409) {
        setSnackbarMessage(
          "This Email ID is already exists. Please check and update accordingly."
        );
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
      } else if (err.response && err.response.status === 400) {
        setSnackbarMessage(`Please fill out all required fields..`);
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      } else {
        setSnackbarMessage("Failed to create. Please try again.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }
    }
  };

  return (
    <div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>
        <div className="card h-100">
          <div className="card-body p-24">
            <div>
              <h6 className="text-md text-primary-light mb-16">
                Profile Image
              </h6>
              {/* Upload Image Start */}
              <div className="mb-24 mt-16">
                <div className="avatar-upload">
                  <div className="avatar-edit position-absolute bottom-0 end-0 me-24 mt-16 z-1 cursor-pointer">
                    {/* File input hidden using CSS */}
                    <input
                      type="file"
                      id="student-image"
                      accept="image/*"
                      className="d-none" // This hides the file input
                      onChange={readURL}
                    />
                    <label
                      htmlFor="student-image" // Bind label to file input
                      className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-primary-20 text-primary-600 border border-primary-600 bg-hover-primary-100 text-lg rounded-circle"
                    >
                      <Icon icon="solar:camera-outline" className="icon" />
                    </label>
                  </div>
                  <div className="avatar-preview">
                    <div
                      id="imagePreview"
                      style={{
                        backgroundImage: `url(${imagePreview})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Upload Image End */}
              <form onSubmit={handleSubmit}>
                <div className="row">
                  {/* <div className="col-sm-12"> */}
                  <div className="mb-20">
                    <label
                      htmlFor="name"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Full Name
                      <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control radius-8"
                      id="name"
                      name="name"
                      value={formState.name}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "" || value.trim() !== "") {
                          handleInputChange(e);
                        }
                      }}
                      onBlur={() => setIsNameTouched(true)} // Mark field as touched when focus is lost
                      placeholder="Enter Full Name"
                      required
                    />
                    {isNameTouched && (
                      <>
                        {formState.name && formState.name.length < 2 && (
                          <small className="text-danger-600">
                            Name must be at least 2 characters long
                          </small>
                        )}
                      </>
                    )}
                  </div>

                  <div className="mb-20">
                    <label
                      htmlFor="user_name"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      User Name
                      <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control radius-8"
                      id="user_name"
                      name="user_name"
                      value={formState.user_name}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "" || value.trim() !== "") {
                          handleInputChange(e);
                        }
                      }}
                      onBlur={() => setIsNameTouched(true)} // Mark field as touched when focus is lost
                      placeholder="Enter User Name"
                      required
                    />
                    {isNameTouched && (
                      <>
                        {formState.user_name &&
                          formState.user_name.length < 2 && (
                            <small className="text-danger-600">
                              User name must be at least 2 characters long
                            </small>
                          )}
                      </>
                    )}
                  </div>
                  <div className="mb-20">
                    <label
                      htmlFor="email"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Email
                      <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control radius-8"
                      id="email"
                      name="email"
                      value={formState.email}
                      onChange={handleInputChange}
                      required
                      placeholder="Enter your email"
                    />
                  </div>

                  <div className="mb-20">
                    <label
                      htmlFor="address"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Address
                      {/* <span className="text-danger-600">*</span> */}
                    </label>
                    <input
                      type="text"
                      className="form-control radius-8"
                      id="address"
                      name="address"
                      value={formState.address}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "" || value.trim() !== "") {
                          handleInputChange(e);
                        }
                      }}
                      // required
                      placeholder="Enter your address"
                    />
                  </div>

                  <div className="mb-20">
                    <label
                      htmlFor="gender"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Gender
                      <span className="text-danger-600">*</span>
                    </label>
                    <select
                      id="gender"
                      name="gender"
                      value={formState.gender}
                      onChange={handleInputChange}
                      className="form-control radius-8"
                      required
                    >
                      <option value="" disabled>
                        Select Gender
                      </option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Others">Others</option>
                    </select>
                  </div>

                  <div className="mb-20">
                    <label
                      htmlFor="education"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Education
                      <span className="text-danger-600">*</span>
                    </label>
                    <div className="custom-select">
                      <select
                        value={selectedEducation || ""}
                        onChange={(e) => {
                          const selectedValue = e.target.value;
                          setSelectedEducation(selectedValue || "");
                        }}
                        className="form-control radius-8"
                        id="country"
                        required
                      >
                        <option value="" disabled>
                          Select Education
                        </option>
                        {qualifications.map((qualification, index) => (
                          <option key={index} value={qualification}>
                            {qualification}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="mb-20">
                    <label
                      htmlFor="country"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Country
                      {/* <span className="text-danger-600">*</span> */}
                    </label>
                    <div className="custom-select">
                      <select
                        value={selectedCountry || ""}
                        onChange={(e) => {
                          setSelectedState("");
                          setSelectedCity("");
                          const selectedValue = e.target.value;
                          setSelectedCountry(selectedValue || "");
                        }}
                        className="form-control radius-8"
                        id="country"
                        // required
                      >
                        <option value="">Select Country</option>
                        {countries.map((country) => (
                          <option key={country?._id} value={country?._id}>
                            {country?.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="mb-20">
                    <label
                      htmlFor="state"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      State
                      {/* <span className="text-danger-600">*</span> */}
                    </label>
                    <div className="custom-select">
                      <select
                        value={selectedState || ""}
                        onChange={(e) => {
                          setSelectedCity("");
                          const selectedValue = e.target.value;
                          setSelectedState(selectedValue || "");
                        }}
                        className="form-control radius-8"
                        id="country"
                        // required
                      >
                        <option value="" disabled>
                          Select State
                        </option>
                        {states?.map((state) => (
                          <option key={state._id} value={state._id}>
                            {state.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="mb-20">
                    <label
                      htmlFor="city"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      City
                    </label>
                    <div className="custom-select">
                      <select
                        value={selectedCity || ""}
                        onChange={(e) => {
                          const selectedValue = e.target.value;
                          setSelectedCity(selectedValue || "");
                        }}
                        className="form-control radius-8"
                        id="country"
                      >
                        <option value="" disabled>
                          Select City
                        </option>
                        {cities?.map((city) => (
                          <option key={city._id} value={city._id}>
                            {city?.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="mb-20">
                    <label
                      htmlFor="mobile"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Contact
                      {/* <span className="text-danger-600">*</span> */}
                    </label>
                    <div className="d-flex">
                      <input
                        type="text"
                        className="form-control radius-8"
                        style={{ width: "80px", marginRight: "8px" }} // Adjust width and margin
                        id="country_code"
                        value={formState.country_code}
                        onChange={(e) => {
                          let value = e.target.value;
                          // Always start with '+'
                          if (!value.startsWith("+")) {
                            value = "+" + value.replace(/[^0-9]/g, "");
                          } else {
                            value = "+" + value.slice(1).replace(/[^0-9]/g, "");
                          }
                          setFormState({
                            ...formState,
                            country_code: value,
                          });
                        }}
                        name="country_code"
                        // readOnly // Make the field non-editable
                        placeholder="Code"
                      />
                      <input
                        type="text"
                        className="form-control radius-8"
                        id="mobile"
                        name="mobile"
                        value={formState.mobile}
                        onChange={(e) => {
                          const regex = /^[0-9]*$/; // Allow numbers only
                          const value = e.target.value;

                          if (
                            (regex.test(value) || value === "") &&
                            value.length <= 15 // Enforce max length
                          ) {
                            handleInputChange(e); // Update state only if valid
                          }
                        }}
                        onBlur={() => {
                          setIsMobileTouched(true); // Mark field as touched when focus is lost
                          if (
                            formState.mobile.length < 8 ||
                            formState.mobile.length > 15
                          ) {
                            setError(
                              "Contact number must be between 8 and 15 digits."
                            );
                          } else {
                            setError(""); // Clear error if valid
                          }
                        }}
                        placeholder="Enter your contact number"
                        maxLength={15} // Ensure no more than 15 characters
                        required
                      />
                    </div>
                    {isMobileTouched && formState.mobile && error && (
                      <small className="text-danger-600">{error}</small>
                    )}
                  </div>

                  <div className="mb-20">
                    <label
                      htmlFor="visa_status"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Visa Status
                      <span className="text-danger-600">*</span>
                    </label>
                    <select
                      id="visa_status"
                      name="visa_status"
                      value={formState.visa_status}
                      onChange={handleInputChange}
                      className="form-control radius-8"
                      required
                    >
                      <option value="" disabled>
                        Select Visa Status
                      </option>
                      <option value="British Citizen">British Citizen</option>
                      <option value="Student">Student</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>

                  {/* Conditionally render the input field when "Other" is selected */}
                  {/* {formState.visa_status === "Other" && (
                      <div className="mb-20">
                        <label
                          htmlFor="other_visa_status"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Specify Other Visa Status
                          <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="text"
                          id="other_visa_status"
                          name="other_visa_status"
                          value={formState.other_visa_status || ""}
                          onChange={handleInputChange}
                          className="form-control radius-8"
                          placeholder="Enter Visa Status"
                          required
                        />
                      </div>
                    )} */}

                  {/* <div className="mb-20">
                    <label
                      htmlFor="batch"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Select Batch
                      <span className="text-danger-600">*</span>
                    </label>
                    <select
                      className="form-control radius-8 form-select"
                      id="batch"
                      required
                      value={selectedBatch || ""}
                      onChange={(e) => setSelectedBatch(e.target.value || "")}
                    >
                      <option value="" disabled>
                        Select Batch
                      </option>
                      {batches.ongoing?.length > 0 ||
                      batches.upcoming?.length > 0 ? (
                        [
                          ...(batches.ongoing || []),
                          ...(batches.upcoming || []),
                        ].map((batch) => (
                          <option key={batch._id} value={batch._id}>
                            {batch?.batch_name} [{batch?.course_id?.coursename}]
                            {batch.batch_start_duration <=
                            new Date().toISOString()
                              ? " (Ongoing)"
                              : " (Upcoming)"}
                          </option>
                        ))
                      ) : (
                        <option value="" disabled>
                          No batches available
                        </option>
                      )}
                    </select>
                  </div> */}
                </div>
                <div className="d-flex align-items-center justify-content-center gap-3">
                  <button
                    type="button"
                    className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                    onClick={() => window.history.back()}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                  >
                    {loading && (
                      <div
                        className="loader-container"
                        style={styles.loaderContainer}
                      >
                        <CircularProgress />
                      </div>
                    )}
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          // variant="filled"
          // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default AddStudent;
